<template>
  <div>
    <div class="paytmimg" v-if="user.phone">
      <img :src="'http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl='+user.phone" alt />
      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-btn flat icon color="blue" @click="download()">
            <v-icon>save</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12 sm4>
          <v-btn flat icon color="indigo" @click="copyText()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
              />
            </svg>
          </v-btn>
        </v-flex>

        <social-sharing
          url="http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl='+user.phone"
          inline-template
        >
          <div>
            <network network="whatsapp">
              <img src="../assets/whatsapp.png" style="width:35px;margin-top:5px" />
            </network>
          </div>
        </social-sharing>
      </v-layout>
    </div>
    <div v-else class="title" style="text-align:center">Login Required</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    download() {
      let vm = this;
      let url =
        "http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl=" +
        vm.user.phone;
      let fileName = "Download.jpg";

      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      };
      xhr.send();
    },
    copyText() {
      let vm = this;
      let inp = document.createElement("input");
      document.body.appendChild(inp);
      let url =
        "http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl=" +
        vm.user.phone;
      inp.value = url;
      inp.select();
      document.execCommand("copy", false);
      inp.remove();
    }
  }
};
</script>


<style scoped>
.paytmimg {
  width: 200px;
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.paytmimg img {
}
</style>

